import { Box, Chip, Stack, Typography } from '@mui/material';
import type { HouseholdDetail } from '@hv/shared';
import { HighlightedText } from '../components/highlight';
import { BRAND } from '../theme';
import { Section } from './Section';

export function NarrativeSection({ h }: { h: HouseholdDetail }) {
  const evidence = h.assessment?.evidence ?? [];
  return (
    <Section title="Applicant Narrative">
      {h.narratives.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          No narrative received yet.
        </Typography>
      )}
      <Stack gap={1.5}>
        {h.narratives.map((n) => (
          <Box key={n.id}>
            <Stack direction="row" gap={1} alignItems="center" mb={0.5}>
              <Typography variant="body2" fontWeight={700}>
                {n.applicantFirstName}
              </Typography>
              <Chip size="small" label={n.source === 'csv_export' ? 'Veracross export' : 'Entered in HV'} sx={{ height: 20, fontSize: 11 }} />
              <Typography variant="caption" color="text.secondary">
                received {n.receivedAt.slice(0, 10)}
              </Typography>
            </Stack>
            <Box
              data-testid="narrative"
              sx={{ bgcolor: '#f8fafc', border: `1px solid ${BRAND.line}`, borderRadius: 2, p: 1.5, fontSize: 14, lineHeight: 1.6, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
            >
              <HighlightedText text={n.text} evidence={evidence} />
            </Box>
          </Box>
        ))}
      </Stack>
    </Section>
  );
}
